<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf"><a class="page" id="pv"></a>To my wife, Hazel, truly an <img alt="" class="hebrew" height="15" src="images/eer-lucas-heb1.jpg" width="56"/>.</p>
<p class="ded">To our sons, Craig and Stuart, each of whom is in their own way a <img alt="" class="hebrew" height="15" src="images/eer-lucas-heb2.jpg" width="48"/>.</p>
<p class="ded1">To their wives, Sevinç and Philippa, each of whom is <img alt="" class="hebrew" height="15" src="images/eer-lucas-heb3.jpg" width="119"/>.</p>
<p class="ded2">To our grandchildren, Michael, Toby and Christine,</p>
<p class="ded3">each of whom is a <img alt="" class="hebrew" height="15" src="images/eer-lucas-heb4.jpg" width="42"/> for us.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-lucas-0005.vue?8c1f992c